import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { getFormValues, reset } from 'redux-form';
import RestockingChargeDialog from './RestockingChargeDialog';
import { IApplicationState } from 'ducks/reducers';

const mapStateToProps = (state: IApplicationState) => ({
  values: getFormValues('RestockingCharge')(state)
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
  {
    resetForm: () => reset('RestockingCharge'),
  },
  dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(RestockingChargeDialog);
